'use client';

import { Box, Button, type SxProps } from '@mui/material';
import { Center, flatSx, FlexColumn } from '@ocodelib/mui';
import clsx from 'clsx';
import NextImage from 'next/image';
import { LoginDialogOpenEvent } from '../events/login-dialog-open';
import { DelayMount } from './DelayMount';

interface Props {
  sx?: SxProps;
  className?: string;
  title?: React.ReactNode;
  hidden?: boolean;
  delay?: number;
}

export function NotLoginView(props: Props) {
  const {
    sx,
    className,
    title = '로그인이 필요한 페이지입니다.',
    hidden = false,
    delay = 300,
  } = props;

  if (hidden) {
    return null;
  }

  return (
    <DelayMount delayMs={delay}>
      <FlexColumn.Center
        alignItems="center"
        className={clsx('NotLoginView-root', className)}
        sx={flatSx(
          {
            position: 'relative',
            width: '100%',
            pb: 4,
          },
          sx,
        )}
      >
        <Center
          sx={{
            width: 200,
            mt: 10,
            mb: {
              xs: 2,
              sm: 3,
            },
            '& img': {
              objectFit: 'contain',
              width: '100%',
              height: 'auto',
            },
          }}
        >
          <NextImage
            src="/_static/images/no-data/img_no_data1.png"
            alt=""
            width={200}
            height={150}
          />
        </Center>
        <Box
          className="NotLoginView-title"
          sx={{
            fontSize: '1.1rem',
            lineHeight: 1.5,
            fontWeight: 400,
            color: '#4F566F',
          }}
        >
          {title}
        </Box>
        <Box mt={4}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              console.log('LoginDialogOpenEvent.send()');
              LoginDialogOpenEvent.emit(Date.now());
            }}
          >
            LOGIN
          </Button>
        </Box>
      </FlexColumn.Center>
    </DelayMount>
  );
}
